import { GET_TRAINING_QUESTIONS, SUBMIT_TRAINING } from '../types/training';
import { RESET_STATE } from '../types/global';

export interface TrainingState {
  trainingQuestions: any[],
  trainingStatus: any
}

const INITIAL_STATE: TrainingState = {
  trainingQuestions: null,
  trainingStatus: null,
};

const trainingReducer = function (state: TrainingState = INITIAL_STATE, action): TrainingState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case GET_TRAINING_QUESTIONS:
      return { ...state, trainingQuestions: action.payload };
    case SUBMIT_TRAINING:
      return { ...state, trainingStatus: action.payload };
    default:
      return state;
  }
};

export default trainingReducer;
